
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import Layout from '../../component/layout'
import { getItem } from '../../../../utils/localStorage';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { toastify } from '../../../../utils/toast';
import { getVisitLogsForFacilityURL, searchByOtp } from '../../../../utils/urls';
import formatISODate from '../../../../utils/formatDate';
import { filterObjectsByAllProperties } from '../../../../utils/filterSearch';

function DigitalLogs() {
    const [visitLogs, setVisitLogs] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(0); // Starting index for current page
    const [rows, setRows] = useState(10); // Records per page
    const [searchTerm, setSearchTerm] = useState('');
    const [userRole, setRole] = useState("")


    const getCurrentUser = async () => {
        try {
            const currentUserValue = await getItem('APPUSER')
            if (currentUserValue) {
                const currentUser = JSON.parse(currentUserValue)
                const role = currentUser.user.role
                setRole(role)
                fetchVisitLogs(role);
            }
        }
        catch (err) {
            console.log(err.message)
        }
    }

    // const fetchVisitLogs = async (page = 0, rows = 10) => {
    //     setLoading(true);
    //     try {
    //         const facilityId = await getItem('selectedFacilityId')
    //         const url = `${getVisitLogsForFacilityURL}/${facilityId}?page=${page}&size=${rows}`;
    //         const response = await makeRequest2(url, 'GET', {});

    //         if (response.success) {
    //             let logs = response.data.data;

    //             // Filter logs to show only "checked in" status for guards
    //             if (userRole === 'guard') {
    //                 logs = logs.filter(log => log.status === 'Checked In');
    //             }
    //             setVisitLogs(logs);
    //             setTotalRecords(response.data.total || response.total);
    //         } else {
    //             throw new Error(response.error);
    //         }
    //     } catch (err) {
    //         toastify(err.message, 'error')
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // Handle page change event from DataTable

    const fetchVisitLogs = async (page = 0, rows = 10, search = searchTerm) => {
        setLoading(true);

        try {
            const facilityId = await getItem('selectedFacilityId');

            const url = `${getVisitLogsForFacilityURL}/${facilityId}?page=${page}&size=${rows}&search=${encodeURIComponent(search)}`;

            const response = await makeRequest2(url, 'GET', {});

            if (response.success) {
                let logs = response.data.data;

                if (userRole === 'guard') {
                    logs = logs.filter(log => log.status === 'Checked In');
                }

                setVisitLogs(logs);
                setTotalRecords(response.data.total || response.total);
            } else {
                throw new Error(response.error);
            }

        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    // const onPage = (event) => {
    //     const page = Math.floor(event.first / event.rows); // Calculate page number
    //     const size = event.rows;

    //     setFirst(event.first);
    //     setRows(event.rows);

    //     // Fetch new data for the selected page
    //     fetchVisitLogs(page, size);
    // };

    const onPage = (event) => {
        const page = Math.floor(event.first / event.rows);
        const size = event.rows;

        setFirst(event.first);
        setRows(event.rows);

        fetchVisitLogs(page, size, searchTerm);
    };

    const startTimeTemplate = (rowData) => {

        if (rowData.startTime !== null && rowData.status !== 'Scheduled') {
            return formatISODate(rowData.startTime)
        }
        else {
            return `...`
        }
    }
    const endTimeTemplate = (rowData) => {
        if (rowData.endTime !== null && rowData.status === 'Checked Out') {
            return formatISODate(rowData.endTime)
        }
        else {
            return `...`
        }

    }
    // const handleInputSearch = async (value) => {
    //     try {
    //         setSearchTerm(value);
    //         if (value === '') {
    //             fetchVisitLogs()
    //         } else {
    //             const results = await filterObjectsByAllProperties(visitLogs, value);
    //             setVisitLogs(results);
    //         }
    //     } catch (error) {
    //         toastify(error.message, 'error');
    //     }
    // };

    const handleInputSearch = (value) => {
        setSearchTerm(value);
        setFirst(0);

        fetchVisitLogs(0, rows, value);
    };

    const statusTemplate = (rowData) => {
        const status = rowData.status
        const statusStyles = {
            'Visit Confirmation': {
                color: '#ff9800',         // Orange
                backgroundColor: '#fff3e0' // Light Orange
            },
            'Scheduled': {
                color: '#4caf50',         // Green
                backgroundColor: '#e8f5e9' // Light Green
            },
            'Checked In': {
                color: '#2196f3',         // Blue
                backgroundColor: '#e3f2fd' // Light Blue
            },
            'Checked Out': {
                color: '#9c27b0',         // Purple
                backgroundColor: '#f3e5f5' // Light Purple
            },
            'Denied': {
                color: '#f44336',         // Red
                backgroundColor: '#ffebee' // Light Red
            }
        };

        return (
            <span
                style={{
                    fontWeight: 'bold',
                    padding: '5px 10px',
                    borderRadius: '15px',
                    ...statusStyles[status] // Apply styles based on status
                }}
            >
                {status}
            </span>
        );

    };
    const HandeFilter = async (status) => {
        try {
            if (status === 'All') {
                fetchVisitLogs()
            }
            else {

                const results = await visitLogs.filter((x) => { return x.status === status })
                setVisitLogs(results);
            }
        }
        catch (error) {
            toastify(error.message, 'error')
        }
    }
    const nameTemplate = (rowData) => {
        return <Link to={'/facility/visitor_access_management/view_digital_log/' + rowData._id}>
            {rowData.visitorName}
        </Link>
    }
    useEffect(() => {
        fetchVisitLogs(0, 10);
        getCurrentUser()
    }, [])


    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/visitor_access_management/digital_logs"}>Digital Logs</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">


                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-3">
                                    <input
                                        className="form-control"
                                        placeholder="Search here"
                                        value={searchTerm}
                                        onChange={(e) => { handleInputSearch(e.target.value) }}
                                    />
                                </div>
                                <div className="col-3" >
                                    <div className="btn-group-dropdown" >
                                        <button
                                            className="btn btn-outline-default dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i className="ti ti-filter"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('All') }}>
                                                All
                                            </Link>
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('Visit Confirmation') }}>
                                                Visit Confirmation
                                            </Link>
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('Scheduled') }}>
                                                Scheduled
                                            </Link>
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('Checked In') }}>
                                                Checked In
                                            </Link>
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('Checked Out') }}>
                                                Checked Out
                                            </Link>
                                            <Link className="dropdown-item" to="#!" onClick={() => { HandeFilter('Denied') }}>
                                                Denied
                                            </Link>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 mt-4">
                                    <DataTable
                                        value={visitLogs}
                                        emptyMessage="No Digital Logs Found."
                                        sortMode="multiple"
                                        paginator
                                        rows={rows}
                                        first={first}
                                        totalRecords={totalRecords}
                                        onPage={onPage}
                                        loading={loading}
                                        stripedRows
                                        tableStyle={{ minWidth: '50rem' }}
                                        lazy // This enables server-side pagination
                                    >
                                        <Column header="Visitor Name" body={nameTemplate} />
                                        <Column field="houseNumber" header="Unit Name" />
                                        <Column field="status" header="Status" body={statusTemplate} sortable />
                                        <Column body={startTimeTemplate} header="Check In Time" />
                                        <Column body={endTimeTemplate} header="Check Out Time" />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    )
}


export default DigitalLogs